/**
 * Created by AlexanderC on 8/21/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CachedRequestException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let CachedRequestException = exports.CachedRequestException = function (_Exception) {
  _inherits(CachedRequestException, _Exception);

  /**
   * @param {String} exception
   */
  function CachedRequestException(exception) {
    _classCallCheck(this, CachedRequestException);

    return _possibleConstructorReturn(this, (CachedRequestException.__proto__ || Object.getPrototypeOf(CachedRequestException)).call(this, `Error while working with cached response: ${exception}`));
  }

  return CachedRequestException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/CachedRequestException.js
// module id = 416
// module chunks = 0